// Acesso ao banco usado pelo painel de administração e pela configuração global (g17_config).
// Extraído de App.js sem alteração de comportamento.
import { sb } from "./supabase";
import { deleteUserFiles } from "./account";

// ── MAIN APP ──────────────────────────────────────────────────────────────────


// ── DB HELPERS: Admin & Notifications ────────────────────────────────────────
export async function dbGetConfig() {
  try {
    const { data } = await sb.from("g17_config").select("*");
    if (!data) return {};
    return Object.fromEntries(data.map(r => [r.key, r.value]));
  } catch { return {}; }
}

export async function dbSetConfig(key, value) {
  try {
    await sb.from("g17_config").upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: "key" });
  } catch {}
}

export async function dbGetUsers() {
  try {
    const { data } = await sb.rpc("get_admin_profiles");
    return data || [];
  } catch { return []; }
}

export async function dbUpdateLastSeen(userId) {
  if (!userId) return;
  try {
    await sb.from("profiles").update({ last_seen_at: new Date().toISOString() }).eq("id", userId);
  } catch {}
}

export async function dbBanUser(userId, banned, adminId) {
  const { error } = await sb.from("profiles").update({ banned }).eq("id", userId);
  if (error) {
    console.error("dbBanUser error:", error);
    return { error };
  }
  if (banned) {
    await sb.rpc("force_signout_user", { target_user_id: userId }).catch(e => console.warn("force_signout:", e));
  }
  // Log the ban action
  try {
    await sb.from("ban_logs").insert({
      user_id: userId,
      admin_id: adminId || null,
      action: banned ? "ban" : "unban",
      created_at: new Date().toISOString(),
    });
  } catch(e) { console.warn("ban_log insert:", e); }
  return { error: null };
}

export async function dbDeleteUser(userId) {
  const tryDel = async (table, col) => { try { await sb.from(table).delete().eq(col, userId); } catch(e) { console.warn("del", table, e.message); } };
  await tryDel("notifications", "target_user_id");
  await tryDel("ban_logs", "user_id");
  await tryDel("post_likes", "user_id");
  await tryDel("post_comments", "user_id");
  await tryDel("posts", "user_id");
  await tryDel("study_sessions", "user_id");
  await tryDel("timer_seconds", "user_id");
  await tryDel("questoes", "user_id");
  await tryDel("projections", "user_id");
  await tryDel("simulados", "user_id");
  await tryDel("user_contests", "user_id");
  await tryDel("cycles", "user_id");
  await tryDel("routines", "user_id");
  // Release access key
  try { await sb.from("access_keys").update({ used_by: null, used_at: null, expires_at: null, is_active: true }).eq("used_by", userId); } catch {}
  try { await sb.from("profiles").update({ access_key_id: null }).eq("id", userId); } catch {}
  try { await sb.from("profiles").delete().eq("id", userId); } catch(e) { console.warn("del profiles:", e.message); }
  // Imagens enviadas pelo usuário (storage)
  await deleteUserFiles(userId);
  // Delete auth user via RPC (apaga em cascata o restante)
  const { error: rpcErr } = await sb.rpc("delete_user_account", { target_user_id: userId });
  if (rpcErr) { console.error("delete_user_account RPC error:", rpcErr); throw new Error(rpcErr.message); }
}

export async function dbSendNotification({ title, body, imageUrls, targetUserId }) {
  try {
    const urls = Array.isArray(imageUrls) ? imageUrls.filter(Boolean) : (imageUrls ? [imageUrls] : []);
    await sb.from("notifications").insert({
      title, body,
      image_url: urls[0] || null,       // backward compat
      image_urls: urls,                 // new multi-image field
      target_user_id: targetUserId || null,
      created_at: new Date().toISOString(),
      is_read: false,
    });
  } catch {}
}
